(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgd-prints-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.tgd-prints-faq').forEach((section) => {
    const items = section.querySelectorAll('.tgd-prints-faq__item');

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;

        items.forEach((otherItem) => {
          if (otherItem !== item) otherItem.removeAttribute('open');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgd-technique-comparator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const createEmpty = () => {
      const span = document.createElement('span');
      span.className = 'tgd-technique-comparator__empty';
      span.textContent = '—';
      return span;
    };

    const createTags = (items) => {
      if (!Array.isArray(items) || items.length === 0) {
        return createEmpty();
      }

      const wrapper = document.createElement('div');
      wrapper.className = 'tgd-technique-comparator__tags';

      items.forEach((item) => {
        const tag = document.createElement('span');
        tag.className = 'tgd-technique-comparator__tag';
        tag.textContent = item;
        wrapper.appendChild(tag);
      });

      return wrapper;
    };

    const createScale = (value, max) => {
      const level = Math.max(0, Math.min(Number(value) || 0, max));

      if (level === 0) {
        return createEmpty();
      }

      const wrapper = document.createElement('div');
      wrapper.className = 'tgd-technique-comparator__scale';

      for (let index = 1; index <= max; index += 1) {
        const dot = document.createElement('span');
        dot.className = `tgd-technique-comparator__dot${index <= level ? ' is-active' : ''}`;
        dot.setAttribute('aria-hidden', 'true');
        dot.textContent = '●';
        wrapper.appendChild(dot);
      }

      return wrapper;
    };

    const renderProperty = (cell, technique, property) => {
      cell.replaceChildren();

      if (!technique) {
        cell.appendChild(createEmpty());
        return;
      }

      if (property === 'short_description') {
        if (technique.shortDescription) {
          cell.textContent = technique.shortDescription;
        } else {
          cell.appendChild(createEmpty());
        }
        return;
      }

      if (property === 'visual_finish') {
        let hasContent = false;

        if (technique.visualImage) {
          const imageWrapper = document.createElement('div');
          imageWrapper.className = 'tgd-technique-comparator__visual-image';

          const image = document.createElement('img');
          image.src = technique.visualImage;
          image.alt = `${technique.name} finish`;
          image.loading = 'lazy';

          imageWrapper.appendChild(image);
          cell.appendChild(imageWrapper);
          hasContent = true;
        }

        if (Array.isArray(technique.visualTags) && technique.visualTags.length > 0) {
          cell.appendChild(createTags(technique.visualTags));
          hasContent = true;
        }

        if (!hasContent) {
          cell.appendChild(createEmpty());
        }
        return;
      }

      if (property === 'feel_relief') {
        const level = Number(technique.reliefLevel) || 0;
        const hasFeel = Boolean(technique.feel);

        if (level === 0 && !hasFeel) {
          cell.appendChild(createEmpty());
          return;
        }

        if (level > 0) {
          const scale = createScale(level, 3);
          scale.setAttribute('aria-label', `Relief level ${level} of 3`);
          cell.appendChild(scale);
        }

        if (hasFeel) {
          const label = document.createElement('div');
          label.className = 'tgd-technique-comparator__value-label';
          label.textContent = technique.feel;
          cell.appendChild(label);
        }
        return;
      }

      if (property === 'detail_level') {
        const level = Number(technique.detailLevel) || 0;
        const scale = createScale(level, 4);
        if (level > 0) {
          scale.setAttribute('aria-label', `Detail level ${level} of 4`);
        }
        cell.appendChild(scale);
        return;
      }

      if (property === 'colour_capability') {
        cell.appendChild(createTags(technique.colourCapability));
        return;
      }

      if (property === 'best_for') {
        cell.appendChild(createTags(technique.bestFor));
        return;
      }

      if (property === 'fabric_compatibility') {
        cell.appendChild(createTags(technique.fabricCompatibility));
        return;
      }

      if (property === 'durability') {
        const level = Number(technique.durability) || 0;
        const scale = createScale(level, 4);
        if (level > 0) {
          scale.setAttribute('aria-label', `Durability ${level} of 4`);
        }
        cell.appendChild(scale);
        return;
      }

      if (property === 'recommended_quantities') {
        cell.appendChild(createTags(technique.recommendedQuantities));
        return;
      }

      if (property === 'price_level') {
        const level = Math.max(0, Math.min(Number(technique.priceLevel) || 0, 4));

        if (level === 0) {
          cell.appendChild(createEmpty());
          return;
        }

        const price = document.createElement('div');
        price.className = 'tgd-technique-comparator__price';
        price.setAttribute('aria-label', `Price level ${level} of 4`);
        price.textContent = '€'.repeat(level);
        cell.appendChild(price);
      }
    };

    const initComparator = (root) => {
      if (!root || root.dataset.tgdComparatorReady === 'true') {
        return;
      }

      const dropdowns = Array.from(root.querySelectorAll('[data-technique-dropdown]'));
      const cells = Array.from(root.querySelectorAll('[data-technique-value]'));
      const records = Array.from(root.querySelectorAll('[data-technique-record]'));

      if (dropdowns.length === 0 || records.length === 0) {
        return;
      }

      const splitList = (value) => {
        if (!value) {
          return [];
        }

        return value
          .split('||')
          .map((item) => item.trim())
          .filter(Boolean);
      };

      const techniques = records.map((record) => ({
        handle: record.dataset.handle,
        name: record.dataset.name || '',
        shortDescription: record.dataset.shortDescription || '',
        visualImage: record.dataset.visualImage || '',
        visualTags: splitList(record.dataset.visualTags),
        reliefLevel: Number(record.dataset.reliefLevel) || 0,
        feel: record.dataset.feel || '',
        detailLevel: Number(record.dataset.detailLevel) || 0,
        colourCapability: splitList(record.dataset.colourCapability),
        bestFor: splitList(record.dataset.bestFor),
        fabricCompatibility: splitList(record.dataset.fabricCompatibility),
        durability: Number(record.dataset.durability) || 0,
        recommendedQuantities: splitList(record.dataset.recommendedQuantities),
        priceLevel: Number(record.dataset.priceLevel) || 0
      }));

      const techniquesByHandle = new Map(
        techniques.map((technique) => [technique.handle, technique])
      );

      const closeDropdown = (dropdown) => {
        const trigger = dropdown.querySelector('[data-technique-trigger]');
        const menu = dropdown.querySelector('[data-technique-menu]');

        dropdown.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
      };

      const openDropdown = (dropdown) => {
        dropdowns.forEach((item) => {
          if (item !== dropdown) {
            closeDropdown(item);
          }
        });

        const trigger = dropdown.querySelector('[data-technique-trigger]');
        const menu = dropdown.querySelector('[data-technique-menu]');

        dropdown.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        menu.hidden = false;
      };

      const renderColumn = (columnIndex) => {
        const dropdown = dropdowns[columnIndex];
        if (!dropdown) {
          return;
        }

        const technique = techniquesByHandle.get(dropdown.dataset.selectedHandle);

        cells
          .filter((cell) => Number(cell.dataset.column) === columnIndex)
          .forEach((cell) => {
            renderProperty(cell, technique, cell.dataset.property);
          });
      };

      const updateDropdownStates = () => {
        const selectedValues = dropdowns.map((dropdown) => dropdown.dataset.selectedHandle);

        dropdowns.forEach((dropdown, dropdownIndex) => {
          const selectedHandle = dropdown.dataset.selectedHandle;

          dropdown.querySelectorAll('[data-technique-option]').forEach((option) => {
            const handle = option.dataset.handle;
            const isSelected = handle === selectedHandle;
            const isUsedElsewhere = selectedValues.some(
              (value, valueIndex) => valueIndex !== dropdownIndex && value === handle
            );

            option.disabled = isUsedElsewhere;
            option.classList.toggle('is-selected', isSelected);
            option.setAttribute('aria-selected', isSelected ? 'true' : 'false');
            option.setAttribute('aria-disabled', isUsedElsewhere ? 'true' : 'false');
          });
        });
      };

      const setSelection = (dropdown, handle) => {
        const technique = techniquesByHandle.get(handle);
        if (!technique) {
          return;
        }

        dropdown.dataset.selectedHandle = handle;
        dropdown.querySelector('[data-technique-trigger-label]').textContent = technique.name;
      };

      dropdowns.forEach((dropdown, columnIndex) => {
        const trigger = dropdown.querySelector('[data-technique-trigger]');
        const menu = dropdown.querySelector('[data-technique-menu]');
        const options = Array.from(dropdown.querySelectorAll('[data-technique-option]'));

        trigger.addEventListener('click', () => {
          if (dropdown.classList.contains('is-open')) {
            closeDropdown(dropdown);
          } else {
            openDropdown(dropdown);
          }
        });

        trigger.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            openDropdown(dropdown);
            const firstEnabled = options.find((option) => !option.disabled);
            firstEnabled?.focus();
          }

          if (event.key === 'Escape') {
            closeDropdown(dropdown);
          }
        });

        options.forEach((option) => {
          option.addEventListener('click', () => {
            if (option.disabled) {
              return;
            }

            setSelection(dropdown, option.dataset.handle);
            updateDropdownStates();
            renderColumn(columnIndex);
            closeDropdown(dropdown);
            trigger.focus();
          });
        });

        menu.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            closeDropdown(dropdown);
            trigger.focus();
          }
        });
      });

      document.addEventListener('click', (event) => {
        dropdowns.forEach((dropdown) => {
          if (!dropdown.contains(event.target)) {
            closeDropdown(dropdown);
          }
        });
      });

      updateDropdownStates();
      dropdowns.forEach((dropdown, columnIndex) => renderColumn(columnIndex));
      root.dataset.tgdComparatorReady = 'true';
    };

    const initAllComparators = (scope = document) => {
      if (scope.matches && scope.matches('[data-tgd-technique-comparator]')) {
        initComparator(scope);
      }

      if (scope.querySelectorAll) {
        scope.querySelectorAll('[data-tgd-technique-comparator]').forEach(initComparator);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllComparators());
    } else {
      initAllComparators();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAllComparators(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
